import { render, staticRenderFns } from "./CommercialDashboard.vue?vue&type=template&id=2d25c202&scoped=true&"
import script from "./CommercialDashboard.vue?vue&type=script&lang=js&"
export * from "./CommercialDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CommercialDashboard.vue?vue&type=style&index=0&id=2d25c202&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d25c202",
  null
  
)

export default component.exports